import {InputFactory} from "./index";

export const save = (input: InputFactory): void => {
    var data: any = {};

    if (localStorage.form) {
        data = JSON.parse(localStorage.form)
    }
    localStorage.setItem('form', JSON.stringify({...data, [input.id]: input.value}))
}
